var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenProposalsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Open_Proposals-Icon",
    d: "M20.25,14.15V18.4a2.179,2.179,0,0,1-1.872,2.18A48.458,48.458,0,0,1,12,21a48.458,48.458,0,0,1-6.378-.42A2.179,2.179,0,0,1,3.75,18.4V14.15m16.5,0A2.18,2.18,0,0,0,21,12.489V8.706a2.179,2.179,0,0,0-1.837-2.175q-1.7-.254-3.413-.387m4.5,8.006a2.036,2.036,0,0,1-.673.38A23.978,23.978,0,0,1,12,15.75a24,24,0,0,1-7.577-1.22,2.016,2.016,0,0,1-.673-.38m0,0A2.18,2.18,0,0,1,3,12.489V8.706A2.179,2.179,0,0,1,4.837,6.531q1.7-.254,3.413-.387m7.5,0V5.25A2.25,2.25,0,0,0,13.5,3h-3A2.25,2.25,0,0,0,8.25,5.25v.894m7.5,0a48.667,48.667,0,0,0-7.5,0M12,12.75h.008v.008H12Z",
    transform: "translate(-2.25 -2.25)",
    fill: "none",
    stroke: "#068453",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenProposalsIcon);
export default __webpack_public_path__ + "static/media/Open-Proposals-Icon.27249208fe249cd83bb3c2c65945b4f0.svg";
export { ForwardRef as ReactComponent };